import { render, staticRenderFns } from "./leistungen-projektmanagement-4.vue?vue&type=template&id=6a7b01bf&"
import script from "./leistungen-projektmanagement-4.vue?vue&type=script&lang=js&"
export * from "./leistungen-projektmanagement-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports